export const ONBOARDING_PATHS = ['/get-started', '/:workspace/quick-start'];
